import { BaseListViewStore, HyperLinkTrackingNumberCellData, FulfillmentOrderIdHyperlinkCellData } from 'core/stores';
import { observable, action, makeObservable } from 'mobx';
import FulfillmentOrderStore from './FulfillmentOrderStore';
import { isSeller, isSuperAdminOrganization } from 'core/utils';
import { LookupStore } from 'modules/lookup/stores';
import { lookupRouteName } from 'common/constants';
import _ from 'lodash';

class FulfillmentOrdersListViewStore extends BaseListViewStore {
	@observable change = false;
	noDataItem = true;
	hasActiveShipment = false;
	fulfillmentOrderStatus = null;
	isBuyShipping = false;

	constructor(rootStore) {
		super(rootStore, {
			listStore: new FulfillmentOrderStore(rootStore),
			queryParams: {
				embed: [],
				filter: null,
				ignore: true,
			},
			findFunction: 'findFulfillmentOrder',
			tableData: {
				columns: [
					{
						key: 'fulfillmentOrderId',
						title: 'FULFILLMENTORDERVIEW.FULFILLMENTORDERID',
						dataCell: FulfillmentOrderIdHyperlinkCellData,
						routeName: 'master.app.main.order.list.detail',
						selected: true,
						width: 200,
						filter: null,
					},
					{
						key: 'fulfillmentOrderStatus.name',
						title: 'FULFILLMENTORDERVIEW.STATUS',
						selected: true,
						width: 200,
						filter: null,
					},
					{
						key: 'warehouseOrganization.applicationTitle',
						title: 'FULFILLMENTORDERVIEW.ASSIGNEDWAREHOUSE',
						selected: true,
						width: 200,
						filter: null,
					},
					{
						key: 'carrierService.name',
						title: 'FULFILLMENTORDERVIEW.ASSIGNEDCARRIER',
						selected: true,
						width: 200,
						filter: null,
					},
					{
						key: 'shipmentInfos.trackingNumber',
						title: 'FULFILLMENTORDERVIEW.TRACKINGNUMBER',
						carrierTypePath: 'carrierService.carrierType.name',
						dataCell: HyperLinkTrackingNumberCellData,
						shipmentStatusPath: 'shipmentInfos.status',
						selected: true,
						width: 200,
						filter: null,
					},
				],
				sortObject: [],
				actions: {},
			},
			permissions: {},
			routes: {
				detail: id =>
					this.rootStore.routerStore.goTo('master.app.main.order.list.detail', {
						id,
					}),
			},
		});
		makeObservable(this);
		this.isSeller = isSeller(rootStore);
		this.isSuperAdminOrganization = isSuperAdminOrganization(rootStore);
		this.lookupStore = new LookupStore(rootStore);
		this.parentView = rootStore.marketplaceOrderDetailViewStore;
		this.getFulfillmentOrderStatuses();
	}

	@action.bound
	getFulfillmentOrderStatuses = async () => {
		await this.lookupStore.find({ rpp: 50, page: 1 }, lookupRouteName.fulfillmentOrderStatus);
	};

	@action.bound setAsChanged() {
		this.change = !this.change;
	}
	@action.bound async findFulfillmentOrder() {}
}

export default FulfillmentOrdersListViewStore;
